module.exports = __webpack_public_path__ + "img/plus.d33e1aab.svg";